import { API } from 'api/config'
import { PeopleMyPeopleResponse } from 'interfaces'

export const getRemienderEmail = async (
	organizationId: number
): Promise<PeopleMyPeopleResponse | null> => {
	let res = null
	await API()
		.get(`/people/people_list/${organizationId}?login_reminder=True`)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.warn('Error:', error.message)
			}
		)
	return res
}
